module.exports = __webpack_public_path__ + "static/Partners-section-4a98cdd638b9dfbf5c1aed6cba827bcf.png";